<template>
  <ParagraphSectionHeaderDefault
    :section-h1-heading="sectionHeader.sectionHeading"
    :section-strapline="sectionHeader.sectionStrapline"
    is-on-dark-background="1"
  />

  <ParagraphHomeHeroCarouselDefault :carousel="homeHeroCarousel" />
</template>

<script setup lang="ts">
import type { SectionHeader } from '~/types';

defineProps<{
  sectionHeader: SectionHeader;
  homeHeroCarousel: any;
}>();
</script>
